import {
  BookingSection,
  ContactSection,
  CustomerSection,
  MobileVisitDetailsCard,
  InvoiceSection,
  IssueSection,
} from './CalloutDetailsSections'
import { ServiceDetailsShell } from './ServiceDetailsShell'
import { useServiceAmend } from './useServiceAmend'
import type { CalloutDetailsScreenProps } from './CalloutDetails.types'
import { useCalloutDetailsSections } from './useCalloutDetailsSections'

export type { CalloutDetailsScreenProps } from './CalloutDetails.types'

export function CalloutDetailsScreen(props: CalloutDetailsScreenProps) {
  const {
    serviceId,
    amendDraft,
    customerSection,
    bookingSection,
    issueSection,
    statusSection,
    contactSection,
    invoiceSection,
  } = useCalloutDetailsSections(props)

  const amend = useServiceAmend(props, amendDraft)

  return (
    <ServiceDetailsShell
      resourceLabel="Callout"
      resourcePlural="callouts"
      title="Callout details"
      blurb="View and edit booking, contact and invoicing details. Move the Callout through allowed statuses or add notes."
      idLabel="Callout ID"
      idValue={props.publicId ?? serviceId}
      status={props.status}
      statusChanges={props.statusChanges}
      getAuthorDisplayName={props.getAuthorDisplayName}
      showHeader={props.showHeader}
      amend={amend}
      revisions={props.revisions}
      unlock={{
        actionLabel: props.status === 'Invoiced' ? 'Move to Review' : 'Move to Booked',
        targetStatus: props.status === 'Invoiced' ? 'Review' : 'Booked',
        requireReason: props.status === 'Invoiced',
        onChangeStatus: (nextStatus, reason) =>
          statusSection.onApplyStatus(nextStatus, reason),
      }}
    >
      <MobileVisitDetailsCard
        address={contactSection.contactAddress}
        contactName={contactSection.contactName}
        contactPhone={contactSection.contactPhone}
      />

      <section className="space-y-4">
        <BookingSection {...bookingSection} />
        <IssueSection {...issueSection} />
        <CustomerSection {...customerSection} />
        <ContactSection {...contactSection} />
        <InvoiceSection {...invoiceSection} />
      </section>
    </ServiceDetailsShell>
  )
}
